import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import en_us from './locales/en_us.json';
import en_gb from './locales/en_gb.json';
import en_za from './locales/en_za.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import zu from './locales/zu.json';
import xh from './locales/xh.json';
import af from './locales/af.json';

export const resources = {
  en: { translation: en },
  en_us: { translation: en_us },
  en_gb: { translation: en_gb },
  en_za: { translation: en_za },
  es: { translation: es },
  fr: { translation: fr },
  zu: { translation: zu },
  xh: { translation: xh },
  af: { translation: af }
};

export function getInitialLanguage(pathname?: string): string {
  const path = pathname || (typeof window !== 'undefined' ? window.location.pathname : '/');
  const match = path.match(/^\/(en_US|en_GB|en_ZA)/i);
  if (match) {
    const raw = match[1].toLowerCase();
    if (raw === 'en_us') return 'en_us';
    return 'en_gb';
  }
  return 'en_gb';
}

const initialLang = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'en_gb',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
